import moment from "moment";

export default function format(date: any, format: any, tz = 'America/Recife') {
    return moment(date).format(format)
}
